import * as THREE from 'three';
import * as tests from '../corps_tests';
import { Corps_cabinet } from '../Corps_cabinet';
import { EventHandling } from './EventHandling';
import { Corps_room } from '../Corps_room';
import { Renderer } from './Renderer';
import { Model3d } from './Model3d';
import { Camera } from './Camera';
import { Scene } from './Scene';
import { JPG } from './JPG';
import { Lights } from './Lights';
import { ID } from './ID';
import { getCabinetStructure } from './chromeExtensionsData';

self.addEventListener('init', async function (data) {
    await new Env(data)
        .init();
});

export class Env {

    static base_url:string;
    static cabinets_cart_data:any;
    static cameraDefault:any;
    static canvas: OffscreenCanvas;
    static canvas_size: { width: number; height: number; };
    static corps_cabinets_cart_data: RequestInfo | URL;
    static corps_panel_position: RequestInfo | URL;
    static data: { [x: string]: any; mousemoveListener: any; data: { corp: { width: any; height: any; depth: any; }; }; };
    static devicePixelRatio: any;
    static doorwindow: any[] = [];
    static geometryLibrary: any[] = [];
    static glftLibrary = {
        block: {}
    };
    static inputElement: HTMLElement | undefined;
    static material_img_folder: any;
    static materialsLibrary: any[] = [];
    static objectsState = {};
    static panels_position: { [x: string]: { [x: string]: { url: string; }; }; };
    static room_layout: string | any[];
    static size_units: number = 3.9370079040527344 / 1000;
    static texture_scalar: number;
    static textures: any[] = [];
    static url_corps_show_form: any;
    static walls_dimention: { floor_thickness: number; wall_thickness: number; wall_height: number; };

    // static manager = {
    //     this: new THREE.LoadingManager(),
    //     onStart: (x, y, z) => {},
    //     onProgress: (x, y, z) => {},
    //     onLoad: () => {}
    // }

    constructor(data) {
        ID.setDefault();
        Env.data = data.detail;
        Env.setData();
        Env.size_units = !Env.panels_position ? 1 / 1000 : Env.size_units;
        Env.texture_scalar = !Env.panels_position ? 3 : 1;
    }

    static setData() {
        for (const i in Env.data) {
            if (i === 'data') {
                for (const j in Env.data[i]) {
                    Env[j] = Env.data[i][j];
                }
            } else {
                Env[i] = Env.data[i];
            }
        }
    }

    async init() {

        THREE.Cache.enabled = true;

        THREE.ColorManagement.enabled = true;

        if(Env.panels_position || Env.cabinets_cart_data) {
            await JPG.setImageBitmaps();
            await Model3d.setModels();
        }

        new Scene();

        new Camera();

        new Renderer();

        Camera.setOrbitControls();

        new Lights();

        new EventHandling();

        Env.cameraDefault = Camera.getCameraSettings();

        Env.draw.worldReady = Env.panels_position || Env.cabinets_cart_data ? true : false;
    }

    static draw = {
        worldReady: false,
        run: function () {
            if (tests.runTest) {
                tests.run();
            } else {
                Env.objectsCreate();
            }
        },
        update: function () {
            if (this.worldReady && !Object.keys(Env.glftLibrary.block).length) {
                this.worldReady = false;
                this.run();
            }
        }
    }

    static objectsCreate() {
        if (Env.panels_position) {
            new Corps_cabinet(Env.panels_position);
        } else if (Env.cabinets_cart_data) {
            new Corps_room();
        }
        self.postMessage({modelready: 'modelready'});
        const cabinets = JSON.stringify(getCabinetStructure());
        self.postMessage({cabinets});
        console.debug(THREE.REVISION)
    }
}